<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-26 09:10:59
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-02 11:50:18
 * @FilePath: /wemeet-admin-new/src/components/chooseLink/components/activeTable.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="活动名称">
            <el-input v-model.trim="queryForm.title" clearable placeholder="请输入名称" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
    </vab-query-form>

    <el-table
      ref="acitveTable"
      v-loading="listLoading"
      border
      :data="activeList"
      :row-key="getRowKeys"
      @select="handleSelectionChangeByActive"
    >
      <el-table-column type="selection" width="55" />

      <el-table-column fixed label="活动标题" prop="title" show-overflow-tooltip />
      <el-table-column fixed label="开始时间" show-overflow-tooltip>
        <template #default="{ row }">
          <span>{{ handleDate(row.startTime) }}</span>
        </template>
      </el-table-column>

      <el-table-column fixed label="结束时间" show-overflow-tooltip>
        <template #default="{ row }">
          <span>{{ handleDate(row.endTime) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="活动地址" prop="address" show-overflow-tooltip />
      <el-table-column label="主办方" prop="organisers" show-overflow-tooltip />
      <el-table-column label="活动人数" prop="peopleNum" show-overflow-tooltip />
      <el-table-column label="活动亮点" prop="sparkle" show-overflow-tooltip />
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNum"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChangeActive"
      @size-change="handleSizeChangeActive"
    />
  </div>
</template>

<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs, nextTick, watch } from 'vue'
  import { activeList } from '@/api/active'
  import { parseTime } from '@/utils/index'
  export default defineComponent({
    name: 'ActiveTable',
    props: {
      multChoose: {
        type: Boolean,
        default: false,
      },
      alreadyChooseData: {
        type: Array,
        default: [],
      },
    },
    emit: ['handleAlreadyData'],
    setup(props, { emit }) {
      const state = reactive({
        queryForm: { title: '', pageNum: 1, pageSize: 10 },
        layout: 'prev, pager, next',
        total: 0,
        // 当前选中id
        echoList: [],
        // 记录值
        alreadyChoose: [],
        chooseVal: [],
        acitveTable: null,
        listLoading: false,
        activeList: [],
      })
      watch(
        () => props.alreadyChooseData,
        (count, prevCount) => {
          state.alreadyChoose = count
        }
      )

      // 增加数据格式类型
      const handleType = (val, type1) => {
        let nArr = JSON.parse(JSON.stringify(val))
        for (let i in nArr) {
          nArr[i]['type'] = type1
        }
        return nArr
      }

      const getRowKeys = (row) => {
        return row.id
      }

      const handleDate = (val) => {
        return parseTime(val)
      }

      /**
       * 活动相关接口
       * */
      // 获取活动列表
      const getActiveData = async () => {
        state.listLoading = true
        const { data } = await activeList(state.queryForm)
        state.activeList = handleType(data.data, 'active')
        state.total = data.total
        state.listLoading = false
        // if (state.echoList.length > 0) {
        //   state.activeList.forEach((item) => {
        //     // 重点： 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
        //     // toggleRowSelection(item, true)：设置当前行数据为选中状态
        //     if (state.echoList.includes(item.id)) {
        //       state.acitveTable.toggleRowSelection(item, true)
        //     }
        //   })
        // }
      }

      const handleSizeChangeActive = (val) => {
        state.queryForm.pageSize = val
        getActiveData()
      }
      const handleCurrentChangeActive = (val) => {
        state.queryForm.pageNum = val
        getActiveData()
      }

      const queryData = () => {
        getActiveData()
      }

      // table 选中 活动
      const handleSelectionChangeByActive = (val, row) => {
        if (!props.multChoose) {
          if (state.echoList.length > 0) {
            console.log('zhix')
            state.echoList.forEach((id, index) => {
              if (id === row.id) {
                state.echoList.splice(index, 1)
                state.chooseVal.splice(index, 1)
                emit('handleChooseDataFun', state.chooseVal, 'remove')
              } else {
                state.echoList = []
                state.chooseVal = []
                state.echoList.push(row.id)
                state.chooseVal.push(row)
                emit('handleChooseDataFun', state.chooseVal, 'add')
              }
            })
          } else {
            state.echoList = []
            state.chooseVal = []
            state.echoList.push(row.id)
            state.chooseVal.push(row)
            emit('handleChooseDataFun', state.chooseVal, 'add')
          }
          state.activeList.forEach((item) => {
            if (val[val.length - 1] === item) {
              state.acitveTable.toggleRowSelection(item, true)
            } else {
              state.acitveTable.toggleRowSelection(item, false)
            }
          })
        } else {
          if (!state.echoList.includes(row.id)) {
            console.log('zhix')
            // 回显数据里没有本条，把这条加进来(选中)
            state.echoList.push(row.id)
            state.chooseVal.push(row)
            emit('handleChooseDataFun', state.chooseVal, 'add')
            state.alreadyChoose.push(row)
          } else {
            // 回显数据里有本条，把这条删除(取消选中)
            emit('handleAlreadyDataFun', row, 'active')
            console.log(state.echoList)
            state.echoList.forEach((id, index) => {
              if (id === row.id) {
                state.echoList.splice(index, 1)
                state.chooseVal.splice(index, 1)
              }
            })
            emit('handleChooseDataFun', state.chooseVal, 'remove')
          }
        }
      }
      getActiveData()

      const getChooseData = () => {
        return state.chooseVal
      }

      const showHasChoose = async (echoList, chooseVal) => {
        console.log(echoList, chooseVal)
        state.echoList = echoList
        state.chooseVal = chooseVal
        await getActiveData()
        state.activeList.forEach((item) => {
          if (state.echoList.includes(item.id)) {
            state.acitveTable.toggleRowSelection(item, true)
          } else {
            state.acitveTable.toggleRowSelection(item, false)
          }
        })
      }

      return {
        ...toRefs(state),
        handleSizeChangeActive,
        handleCurrentChangeActive,
        queryData,
        getActiveData,
        getRowKeys,
        handleSelectionChangeByActive,
        handleDate,
        getChooseData,
        showHasChoose,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
